module.exports = __webpack_public_path__ + "static/media/havwoods-ireland.eabbabc7.png";